import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'

@Component({})
export default class addResurveyMixin extends Vue {
	private data: any = {}
	private resurveyOrder: any = ''
	// private visible = false

	@Prop({ default: true })
	private needBtn!: boolean

	@Prop({})
	private orderId!: any

	@Prop({ default: false })
	private noRequest!: boolean

	@Prop({})
	private revisitId!: any

	@Prop({})
	private latestHosInfo!: any

	@Prop({})
	private addVisible!: any

	@Watch('addVisible', { immediate: true })
	private async onVisibleChange() {
		if (this.addVisible) {
			const res = await TaskApi.getFirstTaskInfo({
				orderId: this.orderId,
				revisitId: this.revisitId,
			})
			const extraData = this.latestHosInfo
				? {
						hospital: this.latestHosInfo.hospital,
						longitude: this.latestHosInfo.longitude,
						latitude: this.latestHosInfo.latitude,
						provinceCode: this.latestHosInfo.province,
						cityCode: this.latestHosInfo.city,
						countryCode: this.latestHosInfo.area,
						clinicArea: this.latestHosInfo.clinicArea,
				  }
				: {}

			this.resurveyOrder = {
				isWholeProcess: true,
				insuranceType: res.data.insuranceType,
				isSendManual: res.data.isSendManual,
				orderId: this.orderId,
				noRequest: this.noRequest,
				revisitId: this.revisitId,
				// finalData为需要拼到最终调用下单接口参数里的字段
				finalData: { revisitId: this.revisitId },
				// extraData为需要给新建表单setFieldsValue的字段
				extraData: extraData,
			}

			this.$set(this.data, 'insuranceType', res.data.insuranceType)
			this.$set(this.data, 'manual2Injured', res.data.isSendManual)
		}
	}

	private toAddTask() {
		// 住院复勘需获取最近住院信息
		this.$emit('getLatestHosInfo')
	}

	private showModal() {
		// this.visible = true
		this.$emit('update:addVisible', true)
	}

	private closeModal() {
		this.$emit('update:addVisible', false)
	}

	private addCallback() {
		// this.visible = false
		this.$emit('update:addVisible', false)
		this.$emit('addCallback')
	}

	private onSubmit(result: any) {
		const values = result.values
		// 任务新建成功回调
		this.$emit('onTaskSubmit', values)

		if (!result.err) {
			// this.visible = false
			this.$emit('update:addVisible', false)
		}
	}
}
